/**
 * 🌟 Inflomatrix 2.0 - React App Entry Point
 */

import { createRoot } from 'react-dom/client';
import App from './app';
import { initObservability } from './observability/init';
import { initPostHog } from './observability/posthog';
import { logger } from './shared/logger';

logger.info('🌟 Inflomatrix 2.0 React App 시작...');

if (typeof window !== 'undefined') {
  logger.info('✅ 브라우저 환경에서 React 앱을 시작합니다.');
  initPostHog();

  const mountApp = (): void => {
    const container = document.getElementById('root');
    if (container) {
      const root = createRoot(container);
      root.render(<App />);
      logger.info('✅ React 앱이 성공적으로 마운트되었습니다.');
    } else {
      logger.error('❌ Root container not found');
    }
  };

  /** Playwright webServer — observability await blocks waitForAppReady when mount is deferred */
  const immediateMount =
    import.meta.env.VITE_E2E_SITE_MOCK === 'true' ||
    import.meta.env.VITE_E2E_IMMEDIATE_MOUNT === 'true';

  if (immediateMount) {
    mountApp();
    void initObservability();
  } else {
    void initObservability().then(mountApp);
  }
} else {
  logger.warn('⚠️ 브라우저 환경이 아닙니다. React 앱을 시작할 수 없습니다.');
}

export default App;
